module.exports = __webpack_public_path__ + "img/niu2.9492277f.jpg";